// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-dialog .el-input-group__append {\n  padding: 0 14px;\n}\n.table-dialog .el-input__suffix-inner {\n  line-height: 28px;\n}\n.el-icon-circle-close {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
